import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/loader/Loadable";

/****Layouts*****/
const FullLayout = Loadable(lazy(() => import("../layouts/FullLayout")));
const BlankLayout = Loadable(lazy(() => import("../layouts/BlankLayout")));
/***** Pages ****/

const StepsForms = Loadable(lazy(() => import("../views/StepsForm/StepsForms")));
const Users = Loadable(lazy(() => import("../views/Users/Users")));
const CreateEditUser = Loadable(lazy(() => import("../views/Users/CreateEditUser")));
const Dashboard = Loadable(lazy(() => import("../views/Dashboard/Dashboard")));
const Profile = Loadable(lazy(() => import("../views/Profile/Profile")));
const Help = Loadable(lazy(() => import("../views/Help/Help")));
const GeneralLogs = Loadable(lazy(() => import("../views/Relatories/GeneralLogs")));
const AccessLogs = Loadable(lazy(() => import("../views/Relatories/AccessLogs")));
const SystemLogs = Loadable(lazy(() => import("../views/Relatories/SystemLogs")));
const SizingLogs = Loadable(lazy(() => import("../views/Relatories/SizingLogs")));
const Historics = Loadable(lazy(() => import("../views/Historic/Historics")));

/***** Parâmetros de Dimensionamento (CRUD) ****/
const AquecedorList = Loadable(lazy(() => import("../views/Parametros/AquecedorList")));
const CreateEditAquecedor = Loadable(lazy(() => import("../views/Parametros/CreateEditAquecedor")));
const AquecedorTabelaList = Loadable(lazy(() => import("../views/Parametros/AquecedorTabelaList")));
const CreateEditAquecedorTabela = Loadable(lazy(() => import("../views/Parametros/CreateEditAquecedorTabela")));
const FiltroList = Loadable(lazy(() => import("../views/Parametros/FiltroList")));
const CreateEditFiltro = Loadable(lazy(() => import("../views/Parametros/CreateEditFiltro")));
const GeradorCloroList = Loadable(lazy(() => import("../views/Parametros/GeradorCloroList")));
const CreateEditGeradorCloro = Loadable(lazy(() => import("../views/Parametros/CreateEditGeradorCloro")));
const MesList = Loadable(lazy(() => import("../views/Parametros/MesList")));
const CreateEditMes = Loadable(lazy(() => import("../views/Parametros/CreateEditMes")));
const TemperaturaAguaList = Loadable(lazy(() => import("../views/Parametros/TemperaturaAguaList")));
const CreateEditTemperaturaAgua = Loadable(lazy(() => import("../views/Parametros/CreateEditTemperaturaAgua")));
const TemperaturaArList = Loadable(lazy(() => import("../views/Parametros/TemperaturaArList")));
const CreateEditTemperaturaAr = Loadable(lazy(() => import("../views/Parametros/CreateEditTemperaturaAr")));
const TrocadorComumList = Loadable(lazy(() => import("../views/Parametros/TrocadorComumList")));
const CreateEditTrocadorComum = Loadable(lazy(() => import("../views/Parametros/CreateEditTrocadorComum")));
const TrocadorComum02List = Loadable(lazy(() => import("../views/Parametros/TrocadorComum02List")));
const CreateEditTrocadorComum02 = Loadable(lazy(() => import("../views/Parametros/CreateEditTrocadorComum02")));
const TrocadorInverterList = Loadable(lazy(() => import("../views/Parametros/TrocadorInverterList")));
const CreateEditTrocadorInverter = Loadable(lazy(() => import("../views/Parametros/CreateEditTrocadorInverter")));
const TrocadorInverterGreList = Loadable(lazy(() => import("../views/Parametros/TrocadorInverterGreList")));
const CreateEditTrocadorInverterGre = Loadable(lazy(() => import("../views/Parametros/CreateEditTrocadorInverterGre")));
const TrocadorInverterUltraList = Loadable(lazy(() => import("../views/Parametros/TrocadorInverterUltraList")));
const CreateEditTrocadorInverterUltra = Loadable(lazy(() => import("../views/Parametros/CreateEditTrocadorInverterUltra")));
const VentoList = Loadable(lazy(() => import("../views/Parametros/VentoList")));
const CreateEditVento = Loadable(lazy(() => import("../views/Parametros/CreateEditVento")));
const VolumePiscinaList = Loadable(lazy(() => import("../views/Parametros/VolumePiscinaList")));
const CreateEditVolumePiscina = Loadable(lazy(() => import("../views/Parametros/CreateEditVolumePiscina")));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import("../views/auth/Error")));
const Login = Loadable(lazy(() => import("../views/auth/Login")));
const RecoverPassword = Loadable(lazy(() => import("../views/auth/RecoverPassword")));
const Register = Loadable(lazy(() => import("../views/auth/Register")));
/*****Routes******/

const ThemeRoutes = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      { path: "/", element: <Navigate to="/dashboard" /> },
      { path: "/sizing", exact: true, element: <StepsForms /> },
      { path: "/users", exact: true, element: <Users /> },
      { path: "/create-edit-users", exact: true, element: <CreateEditUser /> },
      { path: "/dashboard", exact: true, element: <Dashboard /> },
      { path: "/profile", exact: true, element: <Profile /> },
      { path: "/general-logs", exact: true, element: <GeneralLogs /> },
      { path: "/access-logs", exact: true, element: <AccessLogs /> },
      { path: "/system-logs", exact: true, element: <SystemLogs /> },
      { path: "/sizing-logs", exact: true, element: <SizingLogs /> },
      { path: "/historics", exact: true, element: <Historics /> },
      { path: "/help", exact: true, element: <Help /> },

      { path: "/parametros/aquecedor", exact: true, element: <AquecedorList /> },
      { path: "/parametros/aquecedor/form", exact: true, element: <CreateEditAquecedor /> },
      { path: "/parametros/aquecedor-tabela", exact: true, element: <AquecedorTabelaList /> },
      { path: "/parametros/aquecedor-tabela/form", exact: true, element: <CreateEditAquecedorTabela /> },
      { path: "/parametros/filtro", exact: true, element: <FiltroList /> },
      { path: "/parametros/filtro/form", exact: true, element: <CreateEditFiltro /> },
      { path: "/parametros/gerador-cloro", exact: true, element: <GeradorCloroList /> },
      { path: "/parametros/gerador-cloro/form", exact: true, element: <CreateEditGeradorCloro /> },
      { path: "/parametros/mes", exact: true, element: <MesList /> },
      { path: "/parametros/mes/form", exact: true, element: <CreateEditMes /> },
      { path: "/parametros/temperatura-agua", exact: true, element: <TemperaturaAguaList /> },
      { path: "/parametros/temperatura-agua/form", exact: true, element: <CreateEditTemperaturaAgua /> },
      { path: "/parametros/temperatura-ar", exact: true, element: <TemperaturaArList /> },
      { path: "/parametros/temperatura-ar/form", exact: true, element: <CreateEditTemperaturaAr /> },
      { path: "/parametros/trocador-comum", exact: true, element: <TrocadorComumList /> },
      { path: "/parametros/trocador-comum/form", exact: true, element: <CreateEditTrocadorComum /> },
      { path: "/parametros/trocador-comum-02", exact: true, element: <TrocadorComum02List /> },
      { path: "/parametros/trocador-comum-02/form", exact: true, element: <CreateEditTrocadorComum02 /> },
      { path: "/parametros/trocador-inverter", exact: true, element: <TrocadorInverterList /> },
      { path: "/parametros/trocador-inverter/form", exact: true, element: <CreateEditTrocadorInverter /> },
      { path: "/parametros/trocador-inverter-gre", exact: true, element: <TrocadorInverterGreList /> },
      { path: "/parametros/trocador-inverter-gre/form", exact: true, element: <CreateEditTrocadorInverterGre /> },
      { path: "/parametros/trocador-inverter-ultra", exact: true, element: <TrocadorInverterUltraList /> },
      { path: "/parametros/trocador-inverter-ultra/form", exact: true, element: <CreateEditTrocadorInverterUltra /> },
      { path: "/parametros/vento", exact: true, element: <VentoList /> },
      { path: "/parametros/vento/form", exact: true, element: <CreateEditVento /> },
      { path: "/parametros/volume-piscina", exact: true, element: <VolumePiscinaList /> },
      { path: "/parametros/volume-piscina/form", exact: true, element: <CreateEditVolumePiscina /> },

      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/auth",
    element: <BlankLayout />,
    children: [
      { path: "login", element: <Login />},
      { path: "recover-password", element: <RecoverPassword />},
      { path: "register", element: <Register />},
      { path: "404", element: <Error /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default ThemeRoutes;
